<template>
  <b-modal
    id="interviewroundmodal"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    size="lg"
    :visible="showModal"
    @hidden="$emit('close-modal')"
  >
    <div class="w-100 p-3 d-flex justify-content-between align-items-center">
      <div class="b-modal-header">Interview Round Details</div>
      <div class="pointer" @click="$emit('close-modal')">
        <img
          class="rotate-on-hover"
          src="../../../assets/img/feedbackform/x-close.svg"
          alt=""
        />
      </div>
    </div>
    <hr class="m-0" />
    <div class="px-3 pb-0 pt-1">
      <div class="triggerasmnt-container mt-2">
        <div class="d-flex align-items-center justify-content-between">
          <div class="triggerasmnt-modal-heads">Select Interview Round</div>
          <div class="ta-card-heads d-flex align-items-center">
            <span class="ta-card-sd">
              {{ selectedCandidate.roundstatusname }} in (
              {{
                candLevel == "F" ? "Final Round" : `Round ${candLevel} `
              }})</span
            >
            <span v-if="candLevel != 'F' && candLevel != '0'">{{
              roundName
            }}</span>
          </div>
        </div>
        <div class="kanban-ir-inner-height">
          <div v-for="process in getAssignedRounds" :key="process.id">
            <div
              v-if="
                process.id != 0 &&
                process.id != 'F' &&
                process.id != 'H' &&
                process.id != 'R' &&
                process.id != 'NI'
              "
              class="
                jdk-ip-modal-cards
                d-flex
                align-items-center
                justify-content-between
                mt-3
              "
            >
              <div class="d-flex align-items-center">
                <div class="allocateradios d-flex align-items-ce nter mt-2">
                  <b-form-radio
                    name="some-radios"
                    v-model="selectedRound"
                    :value="process"
                  >
                  </b-form-radio>
                </div>
                <div class="ml-2">
                  <div class="ta-card-sd">
                    {{ process.type == "f2f" ? "Face to Face" : "Assessment" }}
                  </div>
                  <div class="ta-card-date">{{ process.name }}</div>
                </div>
              </div>
              <div>
                <img
                  v-if="process.type == 'assesment'"
                  src="../../../assets/img/newkanban/ipasmnt.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../../assets/img/newkanban/ipf2f.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="triggerasmnt-container">
        <div class="triggerasmnt-modal-heads">
          Confirm Message <span class="asterik">*</span>
        </div>
        <div class="jdk-ip-confirm-subtxt mt-1">
          Are you sure you want move this candidate to the selected round?
        </div>
        <div class="newmodalinputbox mt-2">
          <b-form-textarea
            rows="2"
            type="text"
            max-rows="5"
            placeholder="Enter"
            v-model.trim="$v.recruiterRemarks.$model"
            :class="$v.recruiterRemarks.$error ? 'error' : ''"
          >
          </b-form-textarea>
        </div>
      </div>
    </div>
    <hr class="mb-0" />
    <div
      class="
        d-flex
        align-items-center
        justify-content-end
        p-2
        bluebtn
        mt-2
        mb-2
      "
    >
      <b-button
        class="acs-cancelBtn-modal w-105px mr-3"
        @click="$emit('close-modal')"
        >Cancel</b-button
      >
      <b-button
        class="acs-addBtn-modal w-105px"
        @click="select()"
        :disabled="Object.keys(selectedRound).length == 0"
        >Select</b-button
      >
    </div>
  </b-modal>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  name: "ActionModal",
  data() {
    return {
      selectedRound: {},
      recruiterRemarks: "",
    };
  },
  props: {
    showModal: Boolean,
    selectedCandidate: Object,
    interviewProcess: Array,
    vendorRounds: Number,
    particularJob: Object,
  },
  validations: {
    recruiterRemarks: {
      required,
    },
  },
  computed: {
    getAssignedRounds() {
      if (this.vendorRounds || this.vendorRounds == 0) {
        return this.interviewProcess.filter(
          (obj) => obj.id <= this.vendorRounds
        );
      } else {
        return this.interviewProcess;
      }
    },
    candLevel() {
      if (
        this.selectedCandidate.customerID[this.particularJob.customerID][
          this.particularJob.jobID
        ].level == "R"
      ) {
        return this.selectedCandidate.customerID[this.particularJob.customerID][
          this.particularJob.jobID
        ].rejectInLevel;
      }
      return this.selectedCandidate.customerID[this.particularJob.customerID][
        this.particularJob.jobID
      ].notInterestedInLevel;
    },
    roundName() {
      for (var i in this.interviewProcess) {
        if (this.interviewProcess[i].id == this.candLevel) {
          return this.interviewProcess[i].name;
        }
      }
      return "";
    },
  },
  methods: {
    select() {
      this.$v.recruiterRemarks.$touch();
      if (!this.$v.$invalid) {
        this.$emit("trigger-action", this.selectedRound, this.recruiterRemarks);
      }
    },
  },
};
</script>

<style></style>
